/*  ==========================================================================
		PHP Variables
		========================================================================== */

// If you need to access variables such as template url, or AJAX url within this file you can use the variable php_variables.template_url or php_variables.ajax_url
// which has been passed in via enqueue-scripts.php

/*  ==========================================================================
		Grid variables - needed for gridcarousel__init
		========================================================================== */

// NOTE: If your updating this make sure to also update the SASS Variables in _variables.scss
const gridSizes = {
  sm: "550",
  md: "700",
  lg: "1000",
  xl: "1200",
  ws: "1400",
  xw: "1600",
  xxw: "1800",
  xxxw: "2000"
};

/*  ==========================================================================
      DOM element variables 
      ========================================================================== */

const body = document.querySelector("body");

/*  ==========================================================================
		Device Detection - Check if is mobile or ipad
		========================================================================== */

let isMobile = false; // initiate as false
const isTouchDevice = !!("ontouchstart" in window);

if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent)) {
  isMobile = true;
}

/*  ==========================================================================
		Create a 100vh css variable
		========================================================================== */

const setViewHeight = function () {
  // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
  let vh = window.innerHeight;
  // Then we set the value in the --vh custom property to the root of the document
  document.documentElement.style.setProperty("--vh", `${vh}px`);
};

setViewHeight();

window.addEventListener("resize", () => {
  setViewHeight();
});

/*  ==========================================================================
		GENERAL - add linklines to links
		========================================================================== */

const linksInit = function () {
  const links = document.querySelectorAll("a:not(.noline):not(.line-added)");
  links.forEach(function (el) {
    if (el.closest(".noline")) {
      return;
    }

    const icon = el.querySelector(".fa, .fa-solid, .fa-regular, .fa-light, .fa-thin, .fa-brands");

    if (el.querySelector("img") < 1) {
      const linkHTML = "<span class='linkline'>" + el.textContent + "</span>";
      el.innerHTML = linkHTML;
      el.classList.add("line-added");
      if (icon) {
        const iconHTML = icon;
        if (icon.classList.contains("fa--left")) {
          el.querySelector(".linkline").before(icon);
        } else {
          el.querySelector(".linkline").after(icon);
        }
      }
    }
  });
  //return true;
}; // linksInit();
linksInit();

/*  ==========================================================================
    GENERAL - accordion
    ========================================================================== */

const accordionQuestions = document.querySelectorAll(".accordion__question");

const accordionInit = function (accordionItems) {
  if (!accordionItems) {
    return;
  }

  accordionItems.forEach(item =>
    item.addEventListener("click", function () {
      item.closest(".accordion__item").classList.toggle("accordion__item--open");
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    })
  );
  window.addEventListener("resize", function () {
    accordionItems.forEach(function (item) {
      if (item.closest(".accordion__item").classList.contains("accordion__item--open")) {
        let panel = item.nextElementSibling;
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    });
  });
}; // accordionInit();
accordionInit(accordionQuestions);

/*  ==========================================================================
    GENERAL - LazyLoad - Enable Lazy load for images
    ========================================================================== */

// Lazy load images (or everything with .lazy)
const lazyLoadInstance = new LazyLoad();

/*  ==========================================================================
  GENERAL - Share Icons
========================================================================== */
const socialLinksInit = function () {
  const socialLinks = document.querySelectorAll(".sociallink--popup");

  if (!socialLinks) {
    return;
  }

  socialLinks.forEach(socialLink =>
    socialLink.addEventListener("click", function (e) {
      e.preventDefault();
      const shareURL = this.getAttribute("href");
      var w = 550;
      var h = 550;
      var left = Number(screen.width / 2 - w / 2);
      var tops = Number(screen.height / 2 - h / 2);
      window.open(
        shareURL,
        "share-dialog",
        "resizable=no, width=" + w + ", height=" + h + ", top=" + tops + ", left=" + left + ""
      );
    })
  );
}; // socialLinksInit();
socialLinksInit();

/*  ==========================================================================
    GENERAL - Fancybox
  ========================================================================== */
const fancyboxInit = function () {
  const fancyboxOptions = {
    Hash: false, // Disabling Hash-based navigation, as it doesn't work on page reload
    Thumbs: false // Disable thumbnails
  };

  Fancybox.bind("[data-fancybox]", fancyboxOptions);
}; // fancyboxInit();

fancyboxInit();

/*  ==========================================================================
	GENERAL - Popup
		========================================================================== */

const pagePopup = document.querySelector("#popup");

const pagePopupInit = function (pagePopup) {
  if (!pagePopup || typeof Fancybox === "undefined") {
    return;
  }

  const popupBtn = document.querySelector("#popup__btn");
  if (!popupBtn) {
    return;
  }

  const isHomepage = document.body.classList.contains("home");
  const isHomepagePopup = popupBtn.classList.contains("homepage");
  const isEveryPagePopup = popupBtn.classList.contains("every-page");

  function setCookie(name, value, days) {
    const expires = new Date(Date.now() + days * 86400 * 1000).toUTCString();
    document.cookie = `${name}=${value}; expires=${expires}; path=/`;
  }

  function getCookie(name) {
    const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
    return match ? match[2] : null;
  }

  function showPopup() {
    Fancybox.show(
      [
        {
          src: "#popup",
          type: "inline"
        }
      ],
      {
        mainClass: "alert",
        dragToClose: false,
        closeButton: false,
        keyboard: false,
        trapFocus: false,
        placeFocusBack: false,
        click: false,
        backdropClick: false
      }
    );
  }

  /* =====================
     MAIN LOGIC
  ====================== */

  // Homepage popup: always show, no cookie
  if (isHomepagePopup && isHomepage) {
    setTimeout(showPopup, 3000);
  }

  // Every-page popup: show everywhere, but respect cookie
  if (isEveryPagePopup && !getCookie("closedpopup")) {
    setTimeout(showPopup, 3000);
  }

  const closePopup = document.querySelector("#close__popup");

  if (closePopup) {
    closePopup.addEventListener("click", function () {
      // Only set cookie for every-page popup
      if (isEveryPagePopup) {
        setCookie("closedpopup", "true", 90);
      }

      Fancybox.close();
    });
  }
};

pagePopupInit(pagePopup);

/*  ==========================================================================
    GENERAL - Services Animation
  ========================================================================== */
const servicesSections = document.querySelectorAll(".services");
const servicesSectionsInit = function () {
  if (!servicesSections) {
    return;
  }
  // Loop through each .services container
  servicesSections.forEach(serviceSection => {
    const items = serviceSection.querySelectorAll(".services__item");
    const imgs = serviceSection.querySelectorAll(".services__img");
    const subitems = serviceSection.querySelectorAll(".services__subitem");

    items.forEach(item => {
      item.addEventListener("mouseenter", () => {
        const target = item.getAttribute("data-heading");

        // Remove active class within this section only
        items.forEach(i => i.classList.remove("active"));
        imgs.forEach(i => i.classList.remove("active"));
        subitems.forEach(i => i.classList.remove("active"));

        // Activate hovered item
        item.classList.add("active");

        // Activate matching image
        const img = serviceSection.querySelector(`.services__img[data-img="${target}"]`);
        if (img) {
          img.classList.add("active");
        }

        // Activate matching subnav item
        const sub = serviceSection.querySelector(`.services__subitem[data-subnav="${target}"]`);
        if (sub) {
          sub.classList.add("active");
        }
      });
    });
  });
}; // servicesSectionsInit();

servicesSectionsInit();

/*  ==========================================================================
    GENERAL - Specification Table Dropdown 
  ========================================================================== */
let selectedMenu = null;
let selectedGrade = null;

const allTables = document.querySelectorAll(".specification-table__tables .table");

function updateTables() {
  allTables.forEach(table => {
    const tableMenu = table.getAttribute("data-menu");
    const tableGrade = table.getAttribute("data-grade");

    const show = (!selectedMenu || tableMenu === selectedMenu) && (!selectedGrade || tableGrade === selectedGrade);

    table.style.display = show ? "block" : "none";
  });
}

function selectSub(subItem) {
  const filterEl = subItem.closest(".specfilter");
  const btn = filterEl.querySelector(".specfilter__btn");
  if (btn) {
    btn.textContent = subItem.textContent;
  }

  selectedGrade = subItem.getAttribute("data-grade");
  updateTables();
}

document.addEventListener("click", e => {
  const clickedFilter = e.target.closest(".specfilter");
  const clickedBtn = e.target.closest(".specfilter__btn");
  const clickedItem = e.target.closest(".specfilter__menu__item");

  // Close dropdowns if clicked outside
  if (!clickedFilter) {
    document.querySelectorAll(".specfilter__menu").forEach(menu => menu.classList.add("hidden"));
    return;
  }

  // Toggle dropdown
  if (clickedBtn) {
    const menu = clickedFilter.querySelector(".specfilter__menu");
    menu.classList.toggle("hidden");
    document.querySelectorAll(".specfilter__menu").forEach(m => {
      if (m !== menu) {
        m.classList.add("hidden");
      }
    });
    return;
  }

  // Main item clicked
  if (clickedItem && clickedItem.classList.contains("specfilter__menu__item--main")) {
    const filterEl = clickedItem.closest(".specfilter");
    const btn = filterEl.querySelector(".specfilter__btn");
    if (btn) {
      btn.textContent = clickedItem.textContent;
    }

    selectedMenu = clickedItem.getAttribute("data-menu");
    selectedGrade = null; // reset sub

    // Show only sub-items matching this main
    document.querySelectorAll(".specfilter__menu__item--sub").forEach(sub => {
      sub.style.display = sub.getAttribute("data-menu") === selectedMenu ? "block" : "none";
    });

    // Automatically select first visible sub-item
    const firstVisibleSub = Array.from(document.querySelectorAll(".specfilter__menu__item--sub")).find(
      sub => sub.style.display !== "none" && sub.getAttribute("data-menu") === selectedMenu
    );
    if (firstVisibleSub) {
      selectSub(firstVisibleSub);
    }

    updateTables();
    filterEl.querySelector(".specfilter__menu").classList.add("hidden");
    return;
  }

  // Sub item clicked
  if (clickedItem && clickedItem.classList.contains("specfilter__menu__item--sub")) {
    selectSub(clickedItem);
    clickedItem.closest(".specfilter").querySelector(".specfilter__menu").classList.add("hidden");
    return;
  }
});

// On load: select first main and corresponding first visible sub
window.addEventListener("DOMContentLoaded", () => {
  const firstMain = document.querySelector(".specfilter__menu__item--main");
  if (!firstMain) {
    return;
  }

  const firstVisibleSub = Array.from(document.querySelectorAll(".specfilter__menu__item--sub")).find(
    sub => sub.getAttribute("data-menu") === firstMain.getAttribute("data-menu")
  );
  if (!firstVisibleSub) {
    return;
  }

  // Set initial selection
  selectedMenu = firstMain.getAttribute("data-menu");
  selectedGrade = firstVisibleSub.getAttribute("data-grade");

  // Update main button
  const mainBtn = firstMain.closest(".specfilter").querySelector(".specfilter__btn");
  if (mainBtn) {
    mainBtn.textContent = firstMain.textContent;
  }

  // Update sub button
  const subBtn = firstVisibleSub.closest(".specfilter").querySelector(".specfilter__btn");
  if (subBtn) {
    subBtn.textContent = firstVisibleSub.textContent;
  }

  if (firstMain) {
    firstMain.click();
  }

  // Show tables
  updateTables();
});

/*  ==========================================================================
    GENERAL - Copy Contact Details 
  ========================================================================== */
const contactBlocks = document.querySelectorAll(".contact");
const contactBlocksInit = function () {
  if (!contactBlocks) {
    return;
  }
  contactBlocks.forEach(block => {
    const copyBtn = block.querySelector(".contact__copy");
    const linkHolder = block.querySelector(".contact__link");

    if (!copyBtn || !linkHolder) {
      return;
    }

    linkHolder.addEventListener("click", function (e) {
      e.stopPropagation(); // prevent accidental parent clicks
      const value = linkHolder.getAttribute("data-copy");

      navigator.clipboard.writeText(value).then(() => {
        copyBtn.textContent = "Copied!";
        setTimeout(() => {
          copyBtn.textContent = "Copy";
        }, 2000);
      });
    });
  });
}; // contactBlocksInit();

contactBlocksInit();

/*  ==========================================================================
    GENERAL - Service List Tab
  ========================================================================== */
const serviceLists = document.querySelectorAll(".serviceslist");

const serviceListsInit = function () {
  if (!serviceLists.length) {
    return;
  }

  serviceLists.forEach(list => {
    const menuItems = list.querySelectorAll(".serviceslist__menu__item");
    const serviceItems = list.querySelectorAll(".serviceslist__item");
    const servicePin = list.querySelector(".featured-services__pin");

    const activateItem = (item, shouldScroll = true) => {
      // Menu active state
      menuItems.forEach(i => i.classList.remove("active"));
      item.classList.add("active");

      const target = item.dataset.name;

      // Show the matching service item
      serviceItems.forEach(service => {
        service.classList.toggle("active", service.dataset.list === target);
      });

      // Scroll only when explicitly allowed
      if (shouldScroll && servicePin) {
        const rawValue = getComputedStyle(document.documentElement).getPropertyValue("--siteheader-height").trim();

        let headerOffset = 0;

        if (rawValue.endsWith("rem")) {
          const remValue = parseFloat(rawValue);
          const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
          headerOffset = remValue * rootFontSize;
        }

        const targetY = servicePin.getBoundingClientRect().top + window.pageYOffset - headerOffset;

        window.scrollTo({
          top: targetY,
          behavior: "smooth"
        });
      }
    };

    // User clicks → scroll
    menuItems.forEach(item => {
      item.addEventListener("click", () => activateItem(item, true));
    });

    // Initial load → no scroll
    if (menuItems.length > 0) {
      activateItem(menuItems[0], false);
    }
  });
};

serviceListsInit();

/*  ==========================================================================
  GENERAL - Product Tab
========================================================================== */
const tabGroups = document.querySelectorAll("[data-tabs]");
const tabGroupsInit = function () {
  if (!tabGroups) {
    return;
  }
  tabGroups.forEach(group => {
    const buttons = group.querySelectorAll(".tabs__btn");
    const panels = group.querySelectorAll(".tabs__panel");

    buttons.forEach(btn => {
      btn.addEventListener("click", () => {
        const target = btn.getAttribute("data-tab");

        // Remove active state
        buttons.forEach(b => b.classList.remove("active"));
        panels.forEach(p => p.classList.remove("active"));

        // Activate clicked tab & its panel
        btn.classList.add("active");
        const panel = group.querySelector(`.tabs__panel[data-panel="${target}"]`);
        if (panel) {
          panel.classList.add("active");
        }
      });
    });
  });
}; // tabGroupsInit();

tabGroupsInit();

/*  ==========================================================================
  GENERAL - Smooth Scroll Animation used in taxonomy-product-type.php
========================================================================== */
document.querySelectorAll('a[href^="#"]').forEach(link => {
  link.addEventListener("click", e => {
    e.preventDefault();

    const target = document.querySelector(link.getAttribute("href"));

    const siteHeaderHeight = getComputedStyle(document.documentElement).getPropertyValue("--siteheader-height").trim();

    const headerHeightPx = cssLengthToPx(siteHeaderHeight);

    const offset = headerHeightPx * 2;

    const elementPos = target.getBoundingClientRect().top + window.scrollY;
    const offsetPos = elementPos - offset;

    window.scrollTo({
      top: offsetPos,
      behavior: "smooth"
    });
  });

  function cssLengthToPx(value) {
    if (value.endsWith("rem")) {
      const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
      return parseFloat(value) * rootFontSize;
    }
    return parseFloat(value); // px fallback
  }
});

/*  ==========================================================================
  GENERAL - Add active class to the subnav as you scroll pass div with the same ID - used in taxonomy-product-type.php
========================================================================== */
// Select all anchor links
const navLinks = document.querySelectorAll(".subnav__pages a");
const navLinksInit = function () {
  if (!navLinks) {
    return;
  }
  // Build an object mapping IDs → link elements
  const linkMap = {};
  navLinks.forEach(link => {
    const id = link.getAttribute("href").replace("#", "");
    linkMap[id] = link;
  });

  // Observe each section
  const sections = document.querySelectorAll("section[id], div[id]");
  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // Remove active from all
          navLinks.forEach(link => link.classList.remove("active"));

          // Add active to matching link
          const link = linkMap[entry.target.id];
          if (link) {
            link.classList.add("active");
          }
        }
      });
    },
    {
      rootMargin: "-20% 0px -60% 0px",
      threshold: 0
    }
  );

  // Attach observer to sections
  sections.forEach(section => observer.observe(section));
}; // navLinksInit();

navLinksInit();

/*  ==========================================================================
    AJAX - AJAX load more / paging
    ========================================================================== */

const loadmoreBtn = document.querySelector(".paging__loadmore");
const loadmoreContainer = document.querySelector(".loadmore-container");

const loadmoreLoadPostsMultiplePages = function (pages) {
  if (pages && pages > 1) {
    //Stopping default scroll back to previous position
    history.scrollRestoration = "manual";

    const currentPage = new URL(window.location);

    //Creating an array on page numbers to map it
    var list = [];
    for (var i = 1; i < pages; i++) {
      list.push(i);
    }

    // Initialising the array of posts pages
    var postsHTML = [];

    const button = loadmoreBtn;
    const buttonText = button.textContent; // store current button text
    button.textContent = "Loading..."; // change the button text, to let the user know we are loading more posts

    // Array of ajax calls
    var allAJAX = list.map(function (page) {
      const data = {
        action: "loadmore",
        query: php_variables.posts, // that's how we get params from wp_localize_script() function
        page: page
      };
      //Updating the url to mtch the page number
      currentPage.searchParams.set("pagenum", page);
      return $.ajax({
        url: php_variables.ajax_url, // AJAX handler
        data: data,
        type: "POST",
        success: function (data) {
          postsHTML[page] = data;
        }
      });
    });

    // Waiting for all the ajax calls to be finished before proceeding
    Promise.all(allAJAX).then(function () {
      // Update current page variable
      php_variables.current_page = pages;

      button.textContent = buttonText; // set back to previous button text

      // Adding the new tiles to the dom
      list.map(page => {
        if (postsHTML[page]) {
          loadmoreContainer.innerHTML = loadmoreContainer.innerHTML + postsHTML[page];
        }
      });

      // Updating the href for the loadmore button
      const nextPage = new URL(window.location);
      nextPage.searchParams.set("pagenum", parseInt(pages) + 1);
      button.href = nextPage;

      // if last page, remove the button..
      if (parseInt(php_variables.current_page) === parseInt(php_variables.max_page)) {
        button.style.display = "none";
      }

      // Re-init links to make sure linklines on newly loaded content still work
      linksInit();
      // Re-init lazy load
      lazyLoadInstance.update(); // reinit lazy load after clones

      // Re-init effects
      const effects = document.querySelectorAll(".effect");
      effectsInit(effects);

      // Re-do fancybox events
      setupFancyboxEvents();

      // Scrolling the page to the last known position
      if (localStorage.getItem("scrollPosition")) {
        window.scroll({
          top: parseInt(localStorage.getItem("scrollPosition"), 10),
          behavior: "instant"
        });
      }
    });
  }
};

const loadmoreLoadPosts = function () {
  const button = this;
  const data = {
    action: "loadmore",
    query: php_variables.posts, // that's how we get params from wp_localize_script() function
    page: php_variables.current_page
  };
  let buttonText; // create variable to store button text

  // This AJAX triggers a PHP hook within function-hooks.php called ajax_loadmore_handler
  $.ajax({
    url: php_variables.ajax_url, // AJAX handler
    data: data,
    type: "POST",
    beforeSend: function (xhr) {
      buttonText = button.textContent; // store current button text
      button.textContent = "Loading..."; // change the button text, to let the user know we are loading more posts
    },
    success: function (data) {
      if (data) {
        button.textContent = buttonText; // set back to previous button text
        loadmoreContainer.innerHTML = loadmoreContainer.innerHTML + data; // insert new posts to the loadmore-container, this should be the row that includes the posts
        php_variables.current_page++;

        // Only push state to set the last page number or if there is more pages to load
        const currentPage = new URL(window.location);

        if (parseInt(php_variables.current_page) <= parseInt(php_variables.max_page)) {
          currentPage.searchParams.set("pagenum", php_variables.current_page);
          history.pushState({}, "", currentPage);
        }

        // if last page, remove the button..
        if (parseInt(php_variables.current_page) === parseInt(php_variables.max_page)) {
          button.style.display = "none";
        }
        // Re-init links to make sure linklines on newly loaded content still work
        linksInit();
        // Re-init lazy load
        lazyLoadInstance.update(); // reinit lazy load after clones
        // Re-init effects
        effectsInit();
        // Re-do fancybox events
        setupFancyboxEvents();
      } else {
        button.remove(); // if no data, remove the button as well
      }
    }
  });
}; // loadmoreLoadPosts();

const loadmoreInit = function () {
  if (!loadmoreBtn) {
    return;
  }

  /** When adding fitering you will need to move this part into the filtering call */
  // Checking if the page paramenter is set
  const currentPage = new URL(window.location);
  let currentPageNum = currentPage.searchParams.get("pagenum");

  //If there is more than one page to load
  if (currentPageNum && currentPageNum > 1) {
    currentPageNum = currentPageNum > php_variables.max_page ? php_variables.max_page : currentPageNum;
    loadmoreLoadPostsMultiplePages(currentPageNum);
  }

  loadmoreBtn.addEventListener("click", loadmoreLoadPosts);
}; // loadmoreInit();
loadmoreInit();

/*  ==========================================================================
    Scroll effects
    ========================================================================== */

const effects = document.querySelectorAll(".effect");

const effectsInit = function (effects) {
  if (!effects) {
    return;
  }

  effects.forEach(function (val) {
    const waypoints = new Waypoint({
      element: val,
      handler: function (direction) {
        if (direction === "down") {
          val.classList.add("effect--ready");
        } else {
          val.classList.remove("effect--ready");
        }
      },
      offset: "90%"
    });
  });
}; // effectsInit();
effectsInit(effects);

/*  ==========================================================================
			Grid Carousel 
			========================================================================== */

const gridCarousels = document.querySelectorAll(".row--carousel .owl-carousel:not(.products)");

const gridCarouselInit = function (gridCarousels) {
  if (gridCarousels.length <= 0) {
    return;
  }

  gridCarousels.forEach(elem => {
    const slides = elem.querySelectorAll(".col");
    if (!slides) {
      return;
    }

    const responsiveArray = carouselResponsiveArray(elem);

    // Optional data attribute settings
    const autoplay = elem.dataset.autoplay ? elem.dataset.autoplay : false;
    const autoplayTimeout = elem.dataset.autoplayTimeout ? elem.dataset.autoplayTimeout : 5000;
    const loop = elem.dataset.loop ? elem.dataset.loop : false;
    const nav = elem.dataset.nav ? elem.dataset.nav : false;
    const dots = elem.dataset.dots ? elem.dataset.dots : false;
    // Default for autoheight is "true", so to turn off you need to set the data-attribute to "disable"
    const autoHeight = elem.dataset.autoheight && elem.dataset.autoheight === "disable" ? false : true;

    var owlCarousel = $(elem).owlCarousel({
      autoplay: autoplay,
      autoplayTimeout: autoplayTimeout,
      loop: loop,
      nav: nav,
      dots: dots,
      items: 1,
      navText: [
        "<i class='fa-sharp fa-regular fa-arrow-left'></i>",
        "<i class='fa-sharp fa-regular fa-arrow-right'></i>"
      ],
      responsive: responsiveArray,
      startPosition: slides.length,
      autoHeight: autoHeight,
      onInitialized: function () {
        lazyLoadInstance.update();
        Waypoint.refreshAll();
      }
    });

    // Safari iOS fix, causing a 1px height until a carousel change happened
    var adjustCarouselHeight = setInterval(function () {
      if (owlCarousel.height() > 1) {
        clearInterval(adjustCarouselHeight);
      }
      owlCarousel.trigger("refresh.owl.carousel", [100]);
    }, 300);

    $(elem).on("resized.owl.carousel", function (event) {
      // Refresh waypoints on resize with slight delay - bit of a hack but stop its breaking waypoint animations
      setTimeout(function () {
        Waypoint.refreshAll();
      }, 500);
    });
  });
}; // gridCarouselInit();
gridCarouselInit(gridCarousels);

/*  ==========================================================================
  Products 
========================================================================== */

const caseStudiesCarousels = document.querySelectorAll(".row--carousel .products");

const caseStudiesCarouselsInit = function (caseStudiesCarousels) {
  if (caseStudiesCarousels.length <= 0) {
    return;
  }

  caseStudiesCarousels.forEach(elem => {
    const slides = elem.querySelectorAll(".col");
    if (!slides) {
      return;
    }

    const responsiveArray = carouselResponsiveArray(elem);

    const autoplay = elem.dataset.autoplay ? elem.dataset.autoplay : false;
    const autoplayTimeout = elem.dataset.autoplayTimeout ? elem.dataset.autoplayTimeout : 5000;
    const loop = elem.dataset.loop ? elem.dataset.loop : false;
    const nav = elem.dataset.nav ? elem.dataset.nav : false;
    const dots = elem.dataset.dots ? elem.dataset.dots : false;
    const autoHeight = elem.dataset.autoheight && elem.dataset.autoheight === "disable" ? false : true;

    const owlCarousel = $(elem).owlCarousel({
      autoplay,
      autoplayTimeout,
      loop,
      nav,
      dots,
      items: 1,
      navText: ["<i class='fa-light fa-arrow-left'></i>", "<i class='fa-light fa-arrow-right'></i>"],
      responsive: responsiveArray,
      startPosition: slides.length,
      autoHeight,
      onInitialized: function () {
        lazyLoadInstance.update();
        Waypoint.refreshAll();
      }
    });

    const parentModule = elem.closest(".featured-products__grid");
    if (parentModule) {
      const customPrev = parentModule.querySelector(".slider__left");
      const customNext = parentModule.querySelector(".slider__right");

      if (customPrev) {
        customPrev.addEventListener("click", () => {
          $(elem).trigger("prev.owl.carousel");
        });
      }

      if (customNext) {
        customNext.addEventListener("click", () => {
          $(elem).trigger("next.owl.carousel");
        });
      }

      // Function to update disabled states
      const updateDisabledState = event => {
        const carousel = event.relatedTarget;
        const current = carousel.current();
        const max = carousel.maximum();

        if (!loop) {
          // Disable PREV at start
          if (customPrev) {
            if (current === 0) {
              customPrev.classList.add("disabled");
            } else {
              customPrev.classList.remove("disabled");
            }
          }

          // Disable NEXT at end
          if (customNext) {
            if (current === max) {
              customNext.classList.add("disabled");
            } else {
              customNext.classList.remove("disabled");
            }
          }
        }
      };

      // Bind to init + change
      $(elem).on("initialized.owl.carousel changed.owl.carousel", updateDisabledState);
    }

    // Safari iOS height fix
    var adjustCarouselHeight = setInterval(function () {
      if (owlCarousel.height() > 1) {
        clearInterval(adjustCarouselHeight);
      }
      owlCarousel.trigger("refresh.owl.carousel", [100]);
    }, 300);

    $(elem).on("resized.owl.carousel", function () {
      setTimeout(function () {
        Waypoint.refreshAll();
      }, 500);
    });
  });
};

caseStudiesCarouselsInit(caseStudiesCarousels);

/*  ==========================================================================
    Grid Carousel - Create responsive array 
    ========================================================================== */

function carouselResponsiveArray(elem) {
  let responsiveArray = {};
  const slides = elem.querySelectorAll(".col");
  const classes = slides[0].classList;

  classes.forEach((cl, index) => {
    if (cl.indexOf("col-") !== -1) {
      let className = cl;
      let classWidth = 0;
      let numItems = 4;
      className = cl.replace("col-", "");
      // get min width from col class
      const classGridsize = className.split("-")[0];
      // check this is a string not a number, this will remove up cols that dont have a grid size e.g. col-1-2
      if (isNaN(classGridsize)) {
        className = className.replace(classGridsize + "-", "");
        classWidth = gridSizes[classGridsize];
      } else {
        classWidth = 0;
      }
      // split rest of class into sections (this should now be something like '1-4')
      const otherClassParts = className.split("-");
      // divide second number (e.g 4) by first number (e.g 1) to get number of items
      if (otherClassParts[1]) {
        numItems = otherClassParts[1] / otherClassParts[0];
      } else {
        numItems = 1; // if there isn't a second number it must be a single grid
      }
      responsiveArray[classWidth] = {
        items: numItems
      };
    }
  });

  return responsiveArray;
} // carouselResponsiveArray();

/*  ==========================================================================
	NAVIGATION - mobnav
	========================================================================== */

const mobnav = document.querySelector(".mobnav");
const siteHeaderBd = document.querySelector(".siteheader__bd");
const mobnavToggle = document.querySelector(".mobnav-toggle");
const mobnavOpenclass = "mobnavopen";

const mobnavSetHeight = function () {
  const mobnavHeight = window.innerHeight - siteHeaderBd.getBoundingClientRect().height;
  mobnav.style.height = `${mobnavHeight}px`;
}; // mobnavSetHeight()

const mobnavInit = function () {
  // Open mobnav on click the toggle
  mobnavToggle.addEventListener("click", function (e) {
    e.preventDefault();
    if (!body.classList.contains(mobnavOpenclass)) {
      // IT'S NOT OPEN...
      body.classList.add(mobnavOpenclass);
    } else {
      // IT'S OPEN...
      body.classList.remove(mobnavOpenclass);
    }
  });
}; // mobnavInit()
mobnavInit();

/*  ==========================================================================
      NAVIGATION - mobnav dropdowns
      ========================================================================== */

const mobnavLinks = document.querySelectorAll(".mobnav .sitenav__item--hasdropdown .sitenav__item__dropdownarrow");
const mobnavDropdowns = document.querySelectorAll(".dropdown__list__wrapper");
const mobnavBackToMainButtons = document.querySelectorAll(".back-to:not(.back-to--products)");
const mobnavBackToProductsButtons = document.querySelectorAll(".back-to--products");

const mobnavlinksInit = function () {
  if (!mobnavLinks) {
    return;
  }

  mobnavLinks.forEach(function (mobnavLink) {
    mobnavLink.addEventListener("click", function (e) {
      e.preventDefault();
      body.classList.add("subnavopen");

      mobnavDropdowns.forEach(function (mobnavDropdown) {
        if (mobnavDropdown.dataset.dropdown === mobnavLink.dataset.menu) {
          mobnavDropdown.classList.add("active");
        }
      });
    });
  });

  mobnavBackToMainButtons.forEach(function (mobnavBackToMainButton) {
    mobnavBackToMainButton.addEventListener("click", function (e) {
      mobnavDropdowns.forEach(function (mobnavDropdown) {
        mobnavDropdown.classList.remove("active");
        body.classList.remove("subnavopen");
      });
    });
  });

  mobnavBackToProductsButtons.forEach(function (mobnavBackToProductsButton) {
    mobnavBackToProductsButton.addEventListener("click", function (e) {
      e.preventDefault();

      const wrapper = mobnavBackToProductsButton.closest(".dropdown__list__wrapper");
      if (wrapper) {
        wrapper.classList.remove("active");
      }
    });
  });
}; // mobnavlinksInit();
mobnavlinksInit();

/*  ==========================================================================
			NAVIGATION - sitenav dropdowns
			========================================================================== */

const sitenav = document.querySelector(".sitenav--desktop");
const sitenavdropdown = document.querySelector(".siteheader__dropdown");

const dropdownsInit = function () {
  if (!sitenav || !sitenavdropdown) {
    return;
  }

  const overClass = "sitenav__item--over";
  const navOpenBodyClass = "sitenavopen";
  const activeSectionClass = "dropdownsection--active";

  let navOpen = false;
  let dropdownCloseTimer = null;

  const sitenavItems = document.querySelectorAll(".sitenav__item[data-dropdownsection]");

  // --- Utility Functions ---
  function openDropdown(item) {
    const sectionName = item.dataset.dropdownsection;
    const targetSection = sitenavdropdown.querySelector(".dropdownsection--" + sectionName);

    if (!targetSection) {
      return;
    }

    // Clear previous close timer
    if (dropdownCloseTimer) {
      clearTimeout(dropdownCloseTimer);
      dropdownCloseTimer = null;
    }

    // Remove previous active/over classes
    document
      .querySelectorAll(`.${overClass}, .${activeSectionClass}`)
      .forEach(el => el.classList.remove(overClass, activeSectionClass));
    document.body.classList.add(navOpenBodyClass);
    sitenavdropdown.classList.add("siteheader__dropdown--active");

    // Set new classes
    item.classList.add(overClass);
    targetSection.classList.add(activeSectionClass);

    navOpen = true;
  }

  function closeDropdown() {
    // Remove main dropdown classes
    document
      .querySelectorAll(`.${overClass}, .${activeSectionClass}`)
      .forEach(el => el.classList.remove(overClass, activeSectionClass));
    document.body.classList.remove(navOpenBodyClass);
    sitenavdropdown.classList.remove("siteheader__dropdown--active");

    // Remove active classes from sublinks containers and images
    document
      .querySelectorAll(
        ".dropdownsection__sublinks__containter.active, .dropdownsection__images__img.active, .dropdownsection__links__link.active"
      )
      .forEach(el => el.classList.remove("active"));

    navOpen = false;
  }
  function scheduleCloseDropdown() {
    navOpen = false;
    dropdownCloseTimer = setTimeout(() => {
      if (!navOpen) {
        closeDropdown();
      }
    }, 0);
  }

  // --- Desktop Hover Events ---
  sitenavItems.forEach(item => {
    item.addEventListener("mouseover", () => openDropdown(item));
    item.addEventListener("mouseout", scheduleCloseDropdown);
  });

  sitenavdropdown.addEventListener("mouseover", () => {
    navOpen = true;
    if (dropdownCloseTimer) {
      clearTimeout(dropdownCloseTimer);
    }
  });

  sitenavdropdown.addEventListener("mouseout", scheduleCloseDropdown);

  // --- Touch Devices ---
  if ("ontouchstart" in window) {
    sitenavItems.forEach(item => {
      item.addEventListener("click", e => {
        e.preventDefault();
        if (item.classList.contains(overClass)) {
          closeDropdown();
        } else {
          openDropdown(item);
        }
      });
    });
  }
}; // dropdownsInit();
dropdownsInit();

document.addEventListener("DOMContentLoaded", () => {
  const links = document.querySelectorAll(".dropdownsection__links__link[data-sublinks]");
  const sublinksContainers = document.querySelectorAll(".dropdownsection__sublinks__containter");
  const images = document.querySelectorAll(".dropdownsection__images__img");

  links.forEach(link => {
    link.addEventListener("mouseenter", () => {
      const value = link.dataset.sublinks;

      // Remove active from all elements
      links.forEach(l => l.classList.remove("active"));
      sublinksContainers.forEach(c => c.classList.remove("active"));
      images.forEach(img => img.classList.remove("active"));

      // Add active to hovered link
      link.classList.add("active");

      // Activate matching sublinks container
      const matchingContainer = document.querySelector(".dropdownsection__sublinks__containter--" + value);
      if (matchingContainer) {
        matchingContainer.classList.add("active");
      }

      // Activate matching image
      const matchingImage = document.querySelector(".dropdownsection__images__img--" + value);
      if (matchingImage) {
        matchingImage.classList.add("active");
      }
    });
  });
});

/*  ==========================================================================
	NAVIGATION - Transparent Scroll Down Animation
	========================================================================== */

const transparentScrollInit = function () {
  window.addEventListener("scroll", function () {
    const header = document.querySelector("body.transparent .siteheader");
    if (!header) {
      return;
    }

    if (window.scrollY > 20) {
      header.classList.add("active");
    } else {
      header.classList.remove("active");
    }
  });
}; // transparentScrollInit();
transparentScrollInit();

const header = document.querySelector(".siteheader");
const dropdownItems = document.querySelectorAll(".sitenav__item--hasdropdown");
const dropdownMenu = document.querySelector(".siteheader__dropdown");

dropdownItems.forEach(item => {
  item.addEventListener("mouseenter", () => {
    header.classList.add("hover");
  });

  item.addEventListener("mouseleave", () => {
    // Check if ANY dropdown item is still hovered
    const stillHovered = [...dropdownItems].some(el => el.matches(":hover"));
    if (!stillHovered) {
      header.classList.remove("hover");
    }
  });
});

dropdownMenu.addEventListener("mouseenter", () => {
  header.classList.add("hover");
});

dropdownMenu.addEventListener("mouseleave", () => {
  header.classList.remove("hover");
});

/*  ==========================================================================
	FORM - Trigger after Form Submission
	========================================================================== */

const triggerAfterSubmit = function () {
  jQuery(document).on("gform_confirmation_loaded", function (event, formId) {
    Waypoint.refreshAll();
  });
};

triggerAfterSubmit();

/*  ==========================================================================
	FILTERS - Posts Filtering
	========================================================================== */

const filters = document.querySelector(".filters"),
  filtersToggle = document.querySelector(".filters__toggle"),
  filterSearchToggle = document.querySelector(".filters__search__toggle"),
  filterSearch = document.querySelector(".filters__search"),
  filterSearchClear = document.querySelector(".filters__search__clear"),
  filterSearchInput = document.querySelector(".filters__search__input input");

const filterPageURL = filters ? filters.dataset.url : "";

let filtersInitialLoad = true;

// Get current from filters data

const filterGetFormData = function () {
  let filter_data = {};

  filter_settings.filters.forEach(function (el) {
    let checkedOptions = document.querySelectorAll('input[type="checkbox"][name=' + el.name + "]:checked");
    filter_data[el.name] = [...checkedOptions].map(x => x.value);
  });

  return filter_data;
};

const filterUpdateURL = function (filterData, searchData) {
  let url_params = "";

  for (const [key, value] of Object.entries(filterData)) {
    if (value.length > 0) {
      if (url_params === "") {
        url_params = url_params + "?";
      } else {
        url_params = url_params + "&";
      }
      // Convert values to comma seperated string
      let values = Object.keys(value)
        .map(function (k) {
          return value[k];
        })
        .join(",");

      if (values !== "") {
        url_params = url_params + "filter_" + key + "=" + values;
      } else {
        url_params = "";
      }
    }
  }

  if (searchData) {
    if (url_params === "") {
      url_params = url_params + "?";
    } else {
      url_params = url_params + "&";
    }
    url_params = url_params + "search=" + searchData;
  }

  let currentPageUrl = window.location.href.split("?")[0];
  let newUrl = currentPageUrl + url_params;
  // history.pushState({ path: newUrl }, "", newUrl);

  if (url_params !== "") {
    history.pushState({}, "", newUrl);
    // console.log("history.pushState: ", newUrl);
  }

  if (history.pushState) {
    window.history.pushState({ path: newUrl }, "", newUrl);
  }
};

// Toggles All Content checkbox if there is selected filters within the group
const filterSelectedAllCheckboxes = function (groupName) {
  let noActiveFiltersInGroup = true;

  document.querySelectorAll('input[type="checkbox"][name=' + groupName + "]").forEach(el => {
    if (el.checked === true) {
      noActiveFiltersInGroup = false;
    }
  });
  const allGroupCheckbox = document.querySelector('input[type="checkbox"][name=all_' + groupName + "]");
  if (allGroupCheckbox) {
    allGroupCheckbox.checked = noActiveFiltersInGroup;
  }
};

// Setup up the active tags in the filter bar
const filterAddingActiveTags = function (filterData) {
  let hasClassActive = false;
  // Reset styles
  const fieldsets = document.querySelectorAll(".filters__fieldset");
  fieldsets.forEach(set => {
    set.classList.remove("filters__fieldset--active");
  });

  const fieldsetField = document.querySelectorAll(".filters__fieldset__field");
  fieldsetField.forEach(field => {
    field.classList.remove("filters__fieldset__field--active");
  });

  // Reset tags
  document.querySelector(".filters__tags").classList.remove("filters__tags--active");
  document.querySelector(".filters__activetags__tags").innerHTML = "";

  for (const [key, values] of Object.entries(filterData)) {
    if (values.length > 0) {
      // Make field group active
      document
        .querySelector(".filters__fieldset[data-value='" + key + "']")
        .classList.remove("filters__fieldset--active");

      for (const value of values) {
        // Make input field active

        let filter_input = document
          .querySelector("input[name='" + key + "'][value='" + value + "']")
          .closest(".filters__fieldset__field");

        filter_input.classList.add("filters__fieldset__field--active");
        // Show active tags
        document.querySelector(".filters__tags").classList.add("filters__tags--active");
        // Add tag
        let filter_input_name = filter_input.querySelector(".filters__fieldset__field__label").innerHTML;

        document.querySelector(
          ".filters__activetags__tags"
        ).innerHTML += `<div class="filters__tag" data-name="${key}" data-value="${value}">${filter_input_name} <i class="fas fa-times"></i></div>`;

        hasClassActive = true;
      }
    }

    filterSelectedAllCheckboxes(key);
  }

  return hasClassActive;
};

const filterGetPosts = function (updateURL = false) {
  // Getting the forma data
  let filterData = filterGetFormData();
  let searchData = filterSearchInput.value;

  if (filterData || searchData) {
    // Update url
    if (updateURL) {
      filterUpdateURL(filterData, searchData);
    }

    let activeTagsNotEmpty = filterAddingActiveTags(filterData);

    if ((filtersInitialLoad && (activeTagsNotEmpty || searchData)) || !filtersInitialLoad) {
      filtersInitialLoad = false;

      // get site padder header height
      let siteheaderpadder = document.querySelector(".siteheader");
      let siteheaderpadderHeight = siteheaderpadder.offsetHeight;

      // get teams filter height
      let portFilter = document.querySelector(".filters");
      let portFilterHeight = portFilter.offsetHeight;

      let filterPin = document.querySelector(".filters-pin");

      const filterPinRec = filterPin.getBoundingClientRect();

      const top = window.scrollY + filterPinRec.top - portFilterHeight - siteheaderpadderHeight - 40;

      window.scrollTo({
        top: top,
        behavior: "smooth"
      });

      // If there's an active search, open the search field
      if (searchData) {
        document.querySelector(".filters__search").classList.add("filters__search--open");
        filterSearchClear.classList.add("active");
        // Show active tags
        document.querySelector(".filters__tags").classList.add("filters__tags--active");
      }

      // Start filtering
      document.querySelector(".posts.loadmore-container").classList.add("filtering");

      let getPostsPage = php_variables.current_page;
      const currentPage = new URL(window.location);
      let currentPageNum = currentPage.searchParams.get("pagenum");

      //If there is more than one page to load
      if (currentPageNum && currentPageNum > 1) {
        currentPageNum = currentPageNum > php_variables.max_page ? php_variables.max_page : currentPageNum;

        getPostsPage = currentPageNum;
      }

      // Trigger ajax
      let data = {
        action: "filter",
        query: php_variables.posts, // that's how we get params from wp_localize_script() function in enqueue-scripts.php
        page: php_variables.current_page,
        filter_settings: filter_settings, // passed in via wp_localize_script in filters.php
        filter_data: filterData,
        search_data: searchData
      };

      $.ajax({
        url: php_variables.ajax_url,
        data: data, // form data
        dataType: "json", // this data type allows us to receive objects from the server
        type: "POST",
        success: function (data) {
          // when filter applied:
          // set the current page to 1
          php_variables.current_page = 1;

          // set the new query parameters
          php_variables.posts = data.posts;

          // set the new max page parameter
          php_variables.max_page = data.max_page;

          // hide load more button, if there are not enough posts for the second page

          const pagingLoadmore = document.querySelector(".paging__loadmore");
          if (pagingLoadmore) {
            if (data.max_page < 2) {
              pagingLoadmore.style.display = "none";
            } else {
              pagingLoadmore.style.display = "block";
            }
          }

          // insert the posts to the container
          const loadmoreContainer = document.querySelector(".posts.loadmore-container");
          if (loadmoreContainer) {
            loadmoreContainer.innerHTML = data.content;
            // Finish filtering
            loadmoreContainer.classList.remove("filtering");
          }

          setFilterTagsListeners();

          lazyLoadInstance.update();

          Waypoint.refreshAll();
        },
        error: function (data) {}
      });
    }
  }
};

const setFilterTagsListeners = function () {
  const allFilterTags = document.querySelectorAll(".filters__tag");
  allFilterTags.forEach(tag => {
    tag.addEventListener("click", function () {
      let filter_name = tag.dataset.name;
      let filter_value = tag.dataset.value;
      let filter_input = (document.querySelector(
        "input[name='" + filter_name + "'][value='" + filter_value + "']"
      ).checked = false);
      // Remove tag
      tag.remove();
      // Trigger filter
      filterGetPosts();
    });
  });
};

const filterSetupClearAll = function () {
  const filterClearAll = document.querySelectorAll(".filters__clearall");
  filterClearAll.forEach(btn => {
    btn.addEventListener("click", function () {
      // Clear search
      filterSearchInput.value = "";
      filterSearch.classList.remove("filters__search--open");
      filterSearchClear.classList.remove("active");

      // Remove all tags
      document.querySelector(".filters__tags").classList.remove("filters__tags--active");
      document.querySelector(".filters__activetags__tags").innerHTML = "";
      // Uncheck all inputs
      const filterCheckboxes = document.querySelectorAll(".filters__fieldset__field input");
      filterCheckboxes.forEach(el => (el.checked = false));

      // Trigger filter
      filterGetPosts(true);

      filters.classList.remove("filters--searchopen");
      filters.classList.remove("filters--dropdownopen");
    });
  });
};

// Init Filter on posts pages
const filterInit = function () {
  let currentPageUrl = window.location.href.split("?")[0];

  const submitBtn = document.querySelector(".filters__apply");
  const filterForm = document.querySelector(".filters__form");

  if (filterForm && filterForm.length) {
    // Get Posts based on Filter Form Data
    filterGetPosts(false);

    // Dropdown open & close
    filtersToggle.addEventListener("click", function (e) {
      e.stopPropagation();
      filters.classList.remove("filters--searchopen");
      filters.classList.toggle("filters--dropdownopen");
    });

    // Search open & close
    filterSearchToggle.addEventListener("click", function (e) {
      if (filterSearch.classList.contains("filters__search--open")) {
        filterSearch.classList.remove("filters__search--open");
      } else {
        filterSearch.classList.add("filters__search--open");
        filterSearchInput.focus();
      }
    });
    // Clear search on click
    filterSearchClear.addEventListener("click", function (e) {
      filterSearchInput.value = "";
      filterSearch.classList.remove("filters__search--open");
      filterSearchClear.classList.remove("active");
      filterGetPosts(true);
    });

    // Filter on submit
    filterForm.addEventListener("submit", function (e) {
      // Stop the form from submitting
      e.preventDefault();

      // Call the filtering post function
      filterGetPosts(true);
      filters.classList.remove("filters--searchopen");
      filters.classList.remove("filters--dropdownopen");
    });

    const filterCheckboxes = filterForm.querySelectorAll(".filters__fieldset__field input");

    filterCheckboxes.forEach(checkbox => {
      checkbox.addEventListener("change", function (evt) {
        // Submit for on checkbox click
        filterGetPosts(true);
      });
    });

    // Remove tags on click
    setFilterTagsListeners();

    // Clear all
    filterSetupClearAll();
  }
};

filterInit();
